<template>
  <BContainer
    v-if="user"
    fluid
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BTabs
      v-model="currentTabIndex"
      active-nav-item-class="font-weight-bold text-uppercase text-primary"
      class="mt-3"
    >
      <BTab>
        <template #title>
          <i :class="iconState('fa-file-pen', currentTabIndex === 0)" /> Pendings
        </template>
        <PostingPending
          ref="spPending"
          :tab-index="currentTabIndex"
          @show="showPosting"
        />
      </BTab>

      <BTab>
        <template #title>
          <i :class="iconState('fa-clock-rotate-left', currentTabIndex === 1)" /> Histories
        </template>
        <PostingHistory
          ref="saHistory"
          :tab-index="currentTabIndex"
          @show="showPosting"
        />
      </BTab>
    </BTabs>

    <BModal
      id="modalPrinting"
      size="xl"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      content-class="scrollable-tabs"
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <BTabs
        v-model="state.currentTabIndex"
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        content-class="scrollable"
        nav-class="d-flex flex-row justify-content-start"
      >
        <BTab
          class="p-2"
          title-item-class="justify-content-start"
        >
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-list-tree mr-1" />
              <b class="is-tab-active">Products</b>
            </div>
          </template>
          <BRow class="mx-0 mt-1 mb-0">
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>
                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Transaction Number"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.transaction_number"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Document Number"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.document_number"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Withdrawal Type"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.headers.withdrawal_type"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Withdrawal To"
                    class="mb-2"
                  >
                    <strong
                      v-if="stockRequest.headers.withdrawal_type === 'Warehouse'"
                      v-text="stockRequest.headers.destination_name"
                    />
                    <strong
                      v-else
                      v-text="stockRequest.headers.supplier_name"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Remarks"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.remarks || 'no remarks'"
                    />
                  </BFormGroup>
                </BCol>
              </BRow>
            </BCol>

            <BCol
              cols="12"
              class="px-0 px-md-1"
            >
              <ValidationObserver
                ref="formProducts"
              >
                <BTable
                  ref="tableProducts"
                  small
                  hover
                  striped
                  bordered
                  responsive
                  show-empty
                  class="mb-0"
                  :items="stockRequest.details"
                  :busy="tableProducts.busy"
                  :filter="tableProducts.filter"
                  :fields="([0, 1].includes(currentTabIndex) ? tableProducts.fields : tableProducts.histories)"
                  :stacked="tableProducts.stacked"
                  :filter-included-fields="tableProducts.filterOn"
                >
                  <template #cell(index)="{ index }">
                    <div
                      class="text-md-nowrap"
                      v-text="tableRowNumber(tableProducts, index)"
                    />
                  </template>

                  <template #cell()="{ value }">
                    <div
                      class="text-md-nowrap d-flex align-items-center min-h-35px px-1"
                      v-text="value"
                    />
                  </template>

                  <template #cell(product_name)="{ value }">
                    <div class="text-md-nowrap d-flex align-items-center min-h-35px px-1">
                      <strong
                        class="font-weight-bolder"
                        v-text="value"
                      />
                    </div>
                  </template>

                  <template #cell(quantity)="{ value }">
                    <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                      <strong
                        class="font-weight-bolder"
                        v-text="numberFormatter(value, '0,0')"
                      />
                    </div>
                  </template>

                  <template #cell(approved_quantity)="{ value }">
                    <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                      <strong
                        class="font-weight-bolder"
                        v-text="numberFormatter(value, '0,0')"
                      />
                    </div>
                  </template>

                  <template #cell(posting_quantity)="{ item, index }">
                    <div
                      v-if="state.posting && Number(currentTabIndex) === 0 && Number(stockRequest.stage) <= 3"
                      class="text-md-nowrap"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        :vid="`details.${index}.posting_quantity`"
                        :rules="{
                          required: true,
                          min_value: state.postLater ? Number(item.approved_quantity) : 1,
                          max_value: Number(item.approved_quantity)
                        }"
                        name="quantity"
                      >
                        <BFormGroup
                          :label-for="`fApprovedQuantity-${index}`"
                          class="mb-0"
                        >
                          <BFormInput
                            :id="`fApprovedQuantity-${index}`"
                            v-model="item.posting_quantity"
                            :state="(errors.length > 0 ? false : null)"
                            :max="item.approved_quantity"
                            placeholder="enter posting quantity here"
                            class="text-center"
                            type="number"
                            step="1"
                            min="0"
                          />
                          <div
                            v-if="(errors.length > 0)"
                            class="invalid-feedback"
                            v-text="errors[0]"
                          />
                        </BFormGroup>
                      </ValidationProvider>
                    </div>
                    <div
                      v-else
                      class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px"
                    >
                      <strong
                        :class="['font-weight-bolder', {
                          'text-danger': Number(item.posting_quantity) <= 0,
                          'text-warning': Number(item.posting_quantity) >= 1 && Number(item.approved_quantity) !== Number(item.posting_quantity),
                          'text-success': Number(item.approved_quantity) === Number(item.posting_quantity)
                        }]"
                        v-text="numberFormatter(item.posting_quantity, '0,0')"
                      />
                    </div>
                  </template>

                  <template #table-busy>
                    <div class="text-center py-5">
                      <BIcon
                        icon="stopwatch"
                        font-scale="5"
                        animation="cylon"
                      />
                      <p class="h3 py-2">
                        <strong>Loading . . .</strong>
                      </p>
                    </div>
                  </template>

                </BTable>
              </ValidationObserver>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-file-lines mr-1" />
              <b class="is-tab-active">Pick-Up Details</b>
            </div>
          </template>

          <BRow
            class="mx-0 mt-1 mb-0"
          >
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Delivery Date"
                    label-for="fvScheduleDate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleDate"
                      v-model="stockRequest.pickup_details.date"
                      type="date"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Logistics Type"
                    label-for="fvPickUpLogisticsType"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvPickUpLogisticsType"
                      v-model="stockRequest.pickup_details.logistics_type"
                      type="text"
                      maxlength="25"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol cols="12" />

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Mobile Number"
                    label-for="fvScheduleMobile"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleMobile"
                      v-model="stockRequest.pickup_details.mobile_number"
                      type="text"
                      maxlength="50"
                      placeholder="no mobile number"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Driver"
                    label-for="fvScheduleDriver"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleDriver"
                      v-model="stockRequest.pickup_details.driver_name"
                      type="text"
                      maxlength="50"
                      placeholder="no driver"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                  offset-md="3"
                  offset="0"
                >
                  <BFormGroup
                    label="Helper"
                    label-for="fvScheduleHelper"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleHelper"
                      v-model="stockRequest.pickup_details.helper"
                      type="text"
                      maxlength="50"
                      placeholder="no helper"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Vehicle Plate"
                    label-for="fvScheduleVehiclePlate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleVehiclePlate"
                      v-model="stockRequest.pickup_details.vehicle_plate"
                      type="text"
                      maxlength="25"
                      placeholder="no vehicle plate"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Vehicle Name"
                    label-for="fvScheduleVehicleName"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleVehicleName"
                      v-model="stockRequest.pickup_details.vehicle_name"
                      type="text"
                      maxlength="50"
                      placeholder="no helper"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

              </BRow>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2 py-4">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-timeline-arrow mr-1" />
              <b class="is-tab-active ml-1">Tracking</b>
            </div>
          </template>

          <BContainer>
            <Timeline
              :stock-request="stockRequest"
            >
              <template #approvals="request">
                <Signatory
                  :stock-request="request"
                  :approver="requesterSignatory"
                />
                <Signatory
                  v-for="(approver, key) in request.approvals"
                  :key="key"
                  :stock-request="request"
                  :approver="approver"
                />
              </template>
            </Timeline>
          </BContainer>
        </BTab>

        <BTab
          title-item-class="align-content-end align-self-end"
        >
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-print mr-1" />
              <b class="is-tab-active ml-1">Printing</b>
            </div>
          </template>
          <iframe
            ref="ipage"
            :src="printing.output"
            height="100%"
            width="100%"
            style="height: calc(90vh - 135px);"
            hide-toolbar
          />
        </BTab>

      </BTabs>
      <template #modal-footer="{ cancel }">
        <div class="flex-grow-1 d-flex justify-content-between mb-0 pb-0 gap-2">
          <div>
            <BButton
              :disabled="state.busy"
              variant="secondary"
              size="sm"
              tabindex="-1"
              @click.prevent="$event => pdfPrint(true)"
            >
              Print
            </BButton>
          </div>
          <div />
          <div class="d-flex gap-2">
            <div
              v-if="state.posting"
              class="d-flex gap-2"
            >
              <BButton
                v-if="Number(currentTabIndex) === 0 && Number(stockRequest.stage) <= Number(currentApprover.stage)"
                :disabled="state.busy"
                variant="primary"
                size="sm"
                tabindex="-1"
                @click.prevent="validatePrinting"
              >
                Mark Document as Printed
              </BButton>
            </div>
            <BButton
              size="sm"
              variant="outline-dark"
              tabindex="-1"
              :disabled="state.busy"
              @click.prevent="$event => {
                $event.target.blur()
                closePrinting(cancel)
              }"
            >
              Close <span class="d-none d-md-inline-block">Window</span>
            </BButton>
          </div>
        </div>
      </template>
    </BModal>

  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MISC from '@/mixins/misc'
import DOCUMENT_PRINTING from '@/mixins/printing/document-atw'
import FORMATTER from '@/mixins/formatter'

import PostingPending from '@/views/lo/atws/printing/Pending.vue'
// import Unposted from '@/views/lo/atws/printing/Unposted.vue'
import PostingHistory from '@/views/lo/atws/printing/History.vue'

import Timeline from '@/components/custom/timeline/Base.vue'
import Signatory from '@/components/custom/timeline/Signatory.vue'

import print from 'vue-print-nb'

export default {

  name: 'VLOAtwPrinting',

  middleware: ['auth', 'lo'],

  metaInfo: () => ({
    title: 'ATW Posting'
  }),

  directives: {
    print
  },

  components: {
    PostingPending,
    // Unposted,
    PostingHistory,
    Timeline,
    Signatory
  },

  mixins: [
    MISC,
    FORMATTER,
    DOCUMENT_PRINTING
  ],

  data () {
    return {
      currentTabIndex: this.getCurrentTabIndexByURL(),
      printing: {
        printed: false,
        output: null
      },
      state: {
        busy: false,
        posting: true,
        currentTabIndex: 0,
        postLater: false
      },
      currentApprover: {
        stage: 0
      },
      stockRequest: {
        id: '',
        stage: 0,
        posted: 0,
        references: {
          document_number: '',
          transaction_number: ''
        },
        headers: {
          withdrawal_type: '',
          destination: 0,
          destination_name: '',
          destination_code: '',
          supplier: 0,
          supplier_name: '',
          supplier_code: ''
        },
        pickup_details: {
          date: '',
          vehicle_plate: '',
          vehicle_name: '',
          driver_name: '',
          mobile_number: '',
          logistics_type: 'In-House',
          is_3pl: 0,
          helper: ''
        },
        details: [],
        approvals: [],
        remarks: ''
      },
      requesterSignatory: {
        stage: 0,
        approver_label: 'Warehouse Officer - Origin',
        approver_action: 'Authority to Withdraw',
        approver_name: '',
        last_seen: '',
        status: 'Requested',
        status_at: '',
        remarks: ''
      },
      tableProducts: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 1, key: 'product_name', class: 'min-w-200px' },
          { mobile: 2, key: 'quantity', class: ['text-center', { 'col-2': !this.isMobile() }] }
        ].sort(this.scaleOnMobile),
        histories: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 1, key: 'product_name', class: 'min-w-200px' },
          { mobile: 2, key: 'quantity', class: ['text-center', { 'col-2': !this.isMobile() }] }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  methods: {

    getCurrentTabIndexByURL () {
      switch (this.$route.params.printer) {
        case 'histories' : {
          return 1
        }
        // case 'unposted' : {
        //   return 1
        // }
        default: {
          return 0
        }
      }
    },

    showPosting (stockRequest, usePosting) {
      this.state.posting = usePosting
      this.state.postLater = false

      const { id, approvable } = stockRequest
      const { pickup_details, withdrawal_details } = approvable

      this.currentApprover.stage = stockRequest.stage

      this.stockRequest = Object.assign(this.stockRequest, {
        id: id,
        stage: approvable.stage,
        references: {
          document_number: approvable.document_number,
          transaction_number: approvable.transaction_number
        },
        headers: {
          withdrawal_type: approvable.withdrawal_type,
          destination: approvable.destination_id,
          destination_name: approvable.destination_name,
          destination_code: approvable.destination_code,
          supplier: approvable.supplier_id,
          supplier_name: approvable.supplier_name,
          supplier_code: approvable.supplier_code,
          origin: approvable.origin_id,
          origin_code: approvable.origin_code,
          origin_name: approvable.origin_name
        },
        pickup_details: {
          date: pickup_details?.date || '',
          vehicle_plate: pickup_details?.vehicle_plate || '',
          vehicle_name: pickup_details?.vehicle_name || '',
          driver_name: pickup_details?.driver_name || '',
          mobile_number: pickup_details?.mobile_number || '',
          is_3pl: pickup_details?.is_3pl || 0,
          logistics_type: Number(pickup_details?.is_3pl) === 1 ? '3rd Party' : 'In-House',
          helper: pickup_details?.helper || ''
        },
        details: withdrawal_details,
        approvals: approvable.approvals,
        remarks: approvable.remarks,
        created_at: approvable.created_at
      })

      this.requesterSignatory = Object.assign(this.requesterSignatory, {
        approver_name: approvable.origin_name,
        status_at: approvable.created_at
      })

      this.state.currentTabIndex = 3

      this.$bvModal.show('modalPrinting')

      this.pdfPrint(false)
    },

    closePrinting (close) {
      if (Number(this.stockRequest.stage) >= 3) {
        if (this.currentTabIndex === 0) {
          this.$refs.spPending.tableRefresh()
        }

        // if (this.currentTabIndex === 1) {
        //   this.$refs.spManual.tableRefresh()
        // }
      }

      close()
    },

    pdfPrint (print = true) {
      const { references, headers, remarks, pickup_details } = this.stockRequest
      const rePrinted = [1, 2].includes(this.currentTabIndex)

      return this.previewVoucher({
        document_number: references.document_number,
        transfer_number: '',
        sap_doc_entry: '',
        transaction_number: references.transaction_number,
        withdrawal_type: headers.withdrawal_type,
        destination_code: headers.destination_code,
        destination_name: headers.destination_name,
        supplier_code: headers.supplier_code,
        supplier_name: headers.supplier_name,
        origin_code: headers.origin_code,
        origin_name: headers.origin_name,
        remarks: remarks,
        vehicle: pickup_details.vehicle_name,
        vehicle_plate: pickup_details.vehicle_plate,
        driver: pickup_details.driver_name,
        driver_mobile: pickup_details.mobile_number,
        logistics_type: pickup_details.logistics_type,
        delivery: this.stockRequest.pickup_details,
        products: this.stockRequest.details,
        approvals: this.stockRequest.approvals,
        stage: this.currentApprover.stage
      }, rePrinted).then(
        async pdfOutput => {
          if (print) {
            return pdfOutput.print()
          }

          this.printing.output = null
          return new Promise(resolve => {
            pdfOutput.getDataUrl(url => {
              this.printing.output = `${url}#toolbar=0`
              resolve(url)
            })
          })
        }
      )
    },

    validatePrinting () {
      this.$nextTick(() => {
        this.$refs.formProducts.validate().then(
          validPosting => {
            if (!validPosting) {
              return this.swalInvalid()
            }

            this.swalConfirmWithRemarks({
              html: 'Mark Authority to Withdraw as Printed?',
              remarksRequired: true,
              confirmButtonText: 'Mark as Printed',
              preConfirm: remarks => {
                return this.$refs.spPending.update({
                  id: this.stockRequest.id,
                  remarks: remarks,
                  status: 'Printed'
                }).then(({ transfer, message }) => {
                  this.swalSuccess(message).then(() => {
                    if (transfer) {
                      this.stockRequest = Object.assign(this.stockRequest, {
                        references: {
                          document_number: transfer.document_number,
                          transaction_number: transfer.transaction_number
                        },
                        stage: transfer.stage
                      })
                    }

                    this.$bvModal.hide('modalPrinting')
                  })
                })
              }
            })
          }
        )
      })
    }

  }
}
</script>
